import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Medicine} from "../../../../store-management/model/medicine.type";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {DragulaService} from "ng2-dragula";

@Component({
  selector: 'vb-sticker-page',
  templateUrl: './sticker-page.component.html',
  styleUrls: ['./sticker-page.component.css']
})
export class StickerPageComponent extends AbstractVisbosComponent implements OnInit {

  Math;

  @Input()
  rows: number = 5;

  @Input()
  cols: number = 5;

  @Input()
  stickerWidth: number = 20;

  @Input()
  stickerHeight: number = 10;

  @Input()
  medicineList: Medicine[] = [];

  @Output()
  stickerSheetCompleted: EventEmitter<boolean> = new EventEmitter();

  private _previewImages: { [medicineCuid: string]: string } = {};
  get previewImages(): { [p: string]: string } {
    return this._previewImages;
  }

  @Input()
  set previewImages(value: { [p: string]: string }) {
    this._previewImages = value;
    this.cd.detectChanges();
  }

  private ratio: number;

  cellContentContainer: Medicine[][] = [];

  private medDrake: any;

  constructor(sessionActions: SessionActions, private dragulaService: DragulaService, cd: ChangeDetectorRef) {
    super(sessionActions, cd);
    this.Math = Math;
  }

  initLayout() {
    for (let r = 0; r < (this.rows); r++) {
      this.cellContentContainer[r] = [];
      for (let c = 0; c < (this.cols); c++) {
        this.cellContentContainer[r][c] = null;
      }
    }

    this.ratio = this.stickerHeight / this.stickerWidth;

  }

  resetContent() {
    this.initLayout();
  }

  hasImage(cuid): boolean {

    if (!cuid) {
      return false;
    }

    return this.previewImages[cuid] != null && this.previewImages[cuid] != '';
  }

  ngOnInit() {
    super.ngOnInit();

    this.initLayout();

    this.medDrake = this.dragulaService.find('medicines').drake;

    this.dataSubscriptions.push(this.dragulaService.drop.subscribe(event => {

      this.medDrake.cancel(true);

      let medicineCuid = event[1].id;
      let medicine = this.medicineList.find(med => med.cuid === medicineCuid);

      let source: HTMLElement = event[3];
      let target: HTMLElement = event[2];

      if (source.classList.contains('sticker')) {
        this.removeFromCell(source);
      }

      if (source.classList.contains('row-drop-area')) {
        this.removeFromRow(source);
      }

      if (target.classList.contains('sticker')) {
        this.dropOnCell(medicine, target);
      }

      if (target.classList.contains('row-drop-area')) {
        this.dropOnRow(medicine, target);
      }

      this.stickerSheetCompleted.emit(!this.hasEmptyCells());

    }));

    this.dataSubscriptions.push(this.dragulaService.cancel.subscribe(event => {
      let source: HTMLElement = event[3];
      if (source.classList.contains('sticker')) {
        this.removeFromCell(source);
        this.stickerSheetCompleted.emit(!this.hasEmptyCells());
      }

    }));

  }

  private dropOnCell(medicine: Medicine, target: HTMLElement) {
    let [targetRow, targetCol] = target.id.replace('cell-', '').split("-");
    this.cellContentContainer[targetRow][targetCol] = medicine;
  }

  private dropOnRow(medicine: Medicine, target: HTMLElement) {
    let targetRow: number = +target.id.replace('row-', '');
    for (let colIndex in this.cellContentContainer[targetRow]) {
      this.cellContentContainer[targetRow][colIndex] = medicine;
    }
  }

  private removeFromCell(source: HTMLElement) {
    let [sourceRow, sourceCol] = source.id.replace('cell-', '').split("-");
    this.cellContentContainer[sourceRow][sourceCol] = null;
  }

  private removeFromRow(source: HTMLElement) {
    let sourceRow: number = +source.id.replace('row-', '');
    for (let colIndex in this.cellContentContainer[sourceRow]) {
      this.cellContentContainer[sourceRow][colIndex] = null;
    }
  }

  hasEmptyCells() {
    let hasNull = false;

    for (let r of this.cellContentContainer) {
      for (let c of r) {
        if (!c) {
          return true;
        }
      }
    }

    return false;
  }

  computeHeight(width: number): string {
    return (width * this.ratio) + "px";
  }

  getDebugContent() {
    return this.cellContentContainer.map(row => row.map(med => med ? med.cuid : med));
  }

}



// WEBPACK FOOTER //
// ./src/app/medicine-stickers/components/custom-sticker-page-layout/sticker-page/sticker-page.component.ts